import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from "./helpers/ScrollToTop";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { HelmetProvider, Helmet } from 'react-helmet-async';

import 'rc-dropdown/assets/index.css';
import 'rc-menu/assets/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router>
        <HelmetProvider>
            <ScrollToTop />
            <App />
        </HelmetProvider>
    </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
